module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ea2a238468543b0a5061314805bd8462.png";